import { OpportunityDetail } from './OpportunityDetail';
import { OPPORTUNITY_ID } from './DetailPageRecords';

// The opportunity demo is the opportunity page, on one featured deal.
export function OpportunityDetailMainSample() {
  return <OpportunityDetail id={OPPORTUNITY_ID} />;
}
